export const GROUPS = {
    PERSON: 'person',
    FIRM: 'firm',
};
